import { render, staticRenderFns } from "./SupplierValuation.vue?vue&type=template&id=c70d0c00"
import script from "./SupplierValuation.vue?vue&type=script&lang=js"
export * from "./SupplierValuation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports